<template>
  <div id="app">
    <!-- <van-button type="primary">主要按钮</van-button>
    <van-button type="info">信息按钮</van-button>
    <van-button type="default">默认按钮</van-button>
    <van-button type="warning">警告按钮</van-button>
    <van-button type="danger">危险按钮</van-button>
    <div class="btn">
    </div>
    <van-button type="primary" @click="getAPI">点击获取所有接口信息</van-button> -->
    <keep-alive>
      <router-view  v-if="$route.meta.isKeepAlive"></router-view>
    </keep-alive>
    <router-view  v-if="!$route.meta.isKeepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    // getAPI () {
    //   this.$http.get('/app/').then(res => {
    //     console.log(res.data)
    //   })
    // }
  }

}
</script>

<style lang="scss">
</style>
